export default "__VITE_ASSET__fW$iPZJW__"